import { useEffect, useMemo, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { toast } from "react-hot-toast";
import UploadImage from "../../Utils/UploadImage";

function TextEditor(props: any) {
  // global variable
  const quillObj: any = useRef();
  const [loading, setLoading] = useState(false);

  function removeExtension(filename: string) {
    return filename.substring(0, filename.lastIndexOf(".")) || filename;
  }

  const uploadFiles = (uploadFileObj: any, filename: any, quillObj: any) => {
    setLoading(true);
    // date added to the file name
    const timestamp = new Date();

    const filenameValue = `${removeExtension(
      filename
    )}_${timestamp.getHours()}${timestamp.getMinutes()}${timestamp.getSeconds()}${timestamp.getMilliseconds()}.${"webp"}`;

    UploadImage({ file: uploadFileObj, name: filenameValue })
      .then(() => {
        const image_url = `${
          "https://d1db3khb4lvg01.cloudfront.net/fit-in/500x300/filters:format(webp)/" +
          filenameValue
        }`;
        const range = quillObj.current.getEditorSelection();
        quillObj.current
          .getEditor()
          .insertEmbed(range.index, "image", image_url);

        setLoading(false);
      })
      .catch(() => {
        toast.error("Something went wrong!!!!!");
        setLoading(false);
      });
  };

  const imageHandler = () => {
    const input: any = document.createElement("input");

    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = async () => {
      const file: any = input?.files[0];

      console.log("we get this file as an output : ", file);

      const fileName = file.name;

      const res = await uploadFiles(file, fileName, quillObj);
    };
  };

  const modules = useMemo(
    () => ({
      toolbar: {
        container: [
          [
            { header: "1" },
            { header: "2" },
            { header: [3, 4, 5, 6] },
            { font: [] },
          ],
          [{ size: [] }],
          ["bold", "italic", "underline", "strike", "blockquote"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ color: [] }, { background: [] }],
          [{ align: [] }],
          ["link", "image", "video"],
          ["clean"],
        ],
        handlers: {
          image: imageHandler,
        },
      },
    }),
    []
  );

  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "color",
    "background",
    "align",
    "link",
    "image",
    "video",
  ];

  return (
    <div>
      <div
        style={{
          position: "absolute",
          height: "100vh",
          width: "100vw",
          background: "rgba(0,0,0,.3)",
          top: 0,
          left: 0,
          display: loading ? "flex" : "none",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1000,
        }}
      >
        <div className={"spin"}></div>
      </div>

      <ReactQuill
        ref={quillObj}
        style={{
          borderRadius: "15px",
          border: "1px solid grey",
          outline: "none",
          width: "calc(100vw - 130px)",
        }}
        value={props.content}
        onChange={props.handleChange}
        modules={modules}
        formats={formats}
        placeholder="Add Content..."
      />
    </div>
  );
}

export default TextEditor;
